import { lazy as reactLazy } from "react";
import { loadWithRetry } from "./utils/dynamicImport";
function lazyWithRetry(loader, options) {
  return /* @__PURE__ */ reactLazy(function() {
    return loadWithRetry(loader, options);
  });
}
export {
  lazyWithRetry
};
//# sourceMappingURL=lazyWithRetry.js.map
